export { default } from './HoldsBatchActions';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsBatchActions/index.js